import React from 'react';
import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import { useHistory } from 'react-router-dom';
import { ButtonWithIcon } from '@els/els-react--button';
import Auth from '@Services/Auth';
import PropTypes from 'prop-types';
import { FEATURES } from '@Constants/rx-ui/constants';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';

import './RsProjectTableToolBar.theme.scss';

function RsProjectTableToolBar({ onDeleteClick, selectedCount, onSelectAllClick, isAllSelected, onImport }) {
  const history = useHistory();
  const importEnabled = Auth.isFeatureEnabled(FEATURES.enableProjectImport);
  return (
    <RsTableToolbar>
      <div className="rs-table-toolbar__left-controls">
        <SelectedItemsControls
          checkAllItems={() => onSelectAllClick()}
          allItemsSelected={!!isAllSelected}
          currentSelectedItems={selectedCount}
          someItemsSelected={selectedCount > 0 && !isAllSelected}
        />
        <ButtonWithIcon
          layout="vertical"
          sprite="Trash"
          type="borderless"
          size="small"
          className="e2e-rs-toolbar-button-delete"
          disabled={selectedCount <= 0}
          onClick={onDeleteClick}>
          Delete
        </ButtonWithIcon>
      </div>
      <div className="rs-table-toolbar__center-controls">
        <ButtonWithIcon sprite="DrawStructureNew" iconRight type="secondary" onClick={() => history.push(RsRoute.DRAW_STRUCTURE)}>
          Draw new structure
        </ButtonWithIcon>
      </div>
      <div className="rs-table-toolbar__right-controls">
        {importEnabled && (
          <ButtonWithIcon sprite="Download" iconRight type="link" size="small" className="e2e-rs-projects-table-import" onClick={onImport}>
            Import
          </ButtonWithIcon>
        )}
      </div>
    </RsTableToolbar>
  );
}
export default RsProjectTableToolBar;

RsProjectTableToolBar.propTypes = {
  selectedCount: PropTypes.number,
  isAllSelected: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onImport: PropTypes.func,
};
